export default __webpack_public_path__ + "static/N0180-8681fbef39aa10f774f90f8baca43e31.png";